export const FORM_TYPES = {
	DATE: "DATE",
	DATETIME: "DATETIME",
	DATE_TIME: "DATE_TIME",
	TEXT: "TEXT",
	NUMBER: "NUMBER",
	CATEGORY: "CATEGORY",
	TREE: "TREE", // single or multiple (radio or checkbox) like CATEGORY, is it SIMPLE LIST or TREE (select all possible or not?)
	BOOLEAN: "BOOLEAN",
	EMAIL: "EMAIL",
};

export const FORM_SUBTYPES = {
	TOGGLE: "TOGGLE",
	LIST: "LIST",
	AUTO_DATE_RANGE_DURATION: "AUTO_DATE_RANGE_DURATION",
};

// Compact type for react-grid-layout
// do we allow static blocks in edition mode
